import Base from "@/plugins/Base";

const module = {
    namespaced: true,
    state: () => ({
        form:{},
    }),
    getters: {
        getForm(state){
            return Base.LocalStorage.get('toles_application_user')
        },
    },
    mutations: {
        setForm(state, value){
            Base.LocalStorage.set('toles_application_user', value);
        },
        setPin(state,value){
            Base.LocalStorage.set('pin', value);
        }
    },
    actions: {
        setTolesApplicationUser({commit},userInformation){
            commit('setForm',userInformation)
        },
        setPin({commit},pin){
            commit('setPin',pin)
        },
        logout(){
             Base.LocalStorage.remove('toles_application_user')
             Base.LocalStorage.remove('sessionExpiryTime')
             Base.LocalStorage.remove('pin')
        }
    }
}
export default module;
